module.exports = __webpack_public_path__ + "img/about-history-video.jpg?c4f11796050bc6a52c781ef68f4aad6c";